import { AnyAction } from 'redux';
import { App, VhvV2Vorbelegungdaten } from '@ps20-frontend/frontend-models';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { TaasTarifrisikoschluesselVHVV2 } from '@ps20/bff-models';
import { IAppState } from '../appState';
import { VhvActions } from '../vhvActions';
import {
  ENTSCHAEDIGUNGSGRENZE_TRAGERISIKO_UNIT_FACTOR,
  TragerisikoWerte,
} from '../model/tragerisiko.model';

function mapTragerisikoFromVorbelegung(
  vorbelegungdaten: VhvV2Vorbelegungdaten,
): TragerisikoWerte | null {
  const tragerisikoBaustein = vorbelegungdaten?.vorvertragBausteinList?.find(
    baustein => baustein?.taasTarifrisikoschluessel === TaasTarifrisikoschluesselVHVV2.TRAGERISIKO,
  );
  if (tragerisikoBaustein?.betrag == null || tragerisikoBaustein?.betrag2 == null) {
    return null;
  }
  return {
    entschaedigungsgrenze:
      tragerisikoBaustein.betrag / ENTSCHAEDIGUNGSGRENZE_TRAGERISIKO_UNIT_FACTOR,
    einzelwert: tragerisikoBaustein.betrag2,
  };
}

export const tragerisikoReducer = function (
  sectionState: TragerisikoWerte = null,
  action: AnyAction,
  appState: IAppState,
): TragerisikoWerte {
  switch (action.type) {
    case VhvActions.TRAGERISIKO_CHANGED: {
      if (appState.angebotsId === action.payload.angebotsId) {
        sectionState = action.payload.tragerisiko;
      }
      return sectionState;
    }
    case VhvActions.PRODUKT_ZUSATZOPTIONEN_VORBELEGT: {
      return mapTragerisikoFromVorbelegung(action.payload) ?? sectionState;
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const vorbelegungdaten: VhvV2Vorbelegungdaten = action.payload;
      if (
        vorbelegungdaten.forApp !== App.VHV_V2 ||
        vorbelegungdaten.angebotsId !== appState.angebotsId
      ) {
        return sectionState;
      }
      return mapTragerisikoFromVorbelegung(vorbelegungdaten) ?? sectionState;
    }
    default:
      return sectionState;
  }
};
